import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=012c1148&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=less&"
import style1 from "./menu.vue?vue&type=style&index=1&id=012c1148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c1148",
  null
  
)

export default component.exports